import { defineComponent as _defineComponent } from 'vue'
import {useRoute, useRouter} from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'BuyTokensView',
  setup(__props, { expose: __expose }) {
  __expose();


const router = useRouter();
const route = useRoute();

const showBackButton = () => {
  return route.name != 'publicSaleInfo';

};
const onBackClick = () => {
    switch (route.name){
      case 'accountType': {
        router.push({name:'publicSaleInfo'});
        break;
      }
      case 'paymentConfirmation': {
        router.push({name:'publicSaleInfo'});
        break;
      }
      case 'emailRegistration': {
        router.push({name:'accountType'});
        break;
      }
      case 'keplrRegistration': {
        router.push({name:'accountType'});
        break;
      }
      case 'metamaskRegistration': {
        router.push({name:'accountType'});
        break;
      }
      case 'emailLogin': {
        router.push({name:'accountType'});
        break;
      }
      default: {
       return undefined;
      }
    }
};


const __returned__ = { router, route, showBackButton, onBackClick }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})